<template>
    <div>
        <!-- ========== PRELOADER ========== -->
        <div id="loading">
            <div class="inner">
                <div class="loading_effect">
                    <div class="object" id="object_one"></div>
                    <div class="object" id="object_two"></div>
                    <div class="object" id="object_three"></div>
                </div>
            </div>
        </div>

        <div class="wrapper">

            <menu-transparent :transparent="true"></menu-transparent>

            <my-header :transparent="true"></my-header>

            <custom-slider></custom-slider>

            <favorite-rooms></favorite-rooms>

            <services></services>

            <!--<blog></blog>-->

            <my-video></my-video>

            <testimonials></testimonials>

            <!--<places></places>-->

            <contact-form></contact-form>

            <my-footer></my-footer>

        </div>

        <!-- ========== BACK TO TOP ========== -->
        <div id="back_to_top">
            <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>

        <!-- ========== NOTIFICATION ========== -->
        <div id="notification"></div>
    </div>
</template>
<script>
    import menuTransparent from '../../components/menuTransparent/MenuTransparent.vue';
    import favoriteRooms from '../../components/favoriteRooms/favoriteRooms.vue';
    import blog from '../../components/blog/Blog.vue';
    import footer from '../../components/footer/Footer.vue';
    import contactForm from '../../components/indexContactForm/ContactForm.vue';
    import places from '../../components/places/Places.vue';
    import testimonials from '../../components/testimonials/Testimonials.vue';
    import services from '../../components/services/Services.vue';
    import myVideo from '../../components/video/Video.vue';
    import myHeader from '../../components/headerTransparent/HeaderTransparent.vue';
    import slider from '../../components/slider/Slider.vue';
    import customSlider from '../../components/slider/CustomSlider.vue';
    export default {
        components : {
            'menu-transparent' : menuTransparent,
            'favorite-rooms' : favoriteRooms,
            blog,
            'my-footer' : footer,
            'contact-form' : contactForm,
            places,
            testimonials,
            services,
            'my-video' : myVideo,
            'my-header' : myHeader,
            slider,
            'custom-slider' : customSlider
        },
    }
</script>


// WEBPACK FOOTER //
// Home.vue?e0d6996e